// SynthNFT — Main entry point
import { initApp } from './renderer';

// Boot the application
initApp();